import { JsonApiModel, Attribute, JsonApiModelConfig } from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'tipos-de-ocorrencia'
})
export class TipoDeOcorrencia extends JsonApiModel {
    @Attribute() nome: string
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/tipo-de-ocorrencia.model.ts